<template>


    <div class="chat-page">
        <!-- Header -->
        <div class="chat-header d-flex align-items-center justify-content-end px-3 py-2">
            <div class="chat-user d-flex me-2 align-items-center">
                <p style="font-weight: bold;" class="user-name me-2 mb-0">أحمد العلي</p>
                <div class="user-avatar rounded-circle me-2">
                    <i style="color: #286090;" class="bi bi-person-circle"></i>
                </div>
            </div>
            <router-link to="/chats">
                <i style="color: #fff;" class="fa-solid fa-arrow-right fa-xl"></i>
            </router-link>
        </div>

        <!-- <body> -->
        <!-- Chat Messages -->
        <div class="chat-messages px-3 py-2">
            <!-- Received Message -->
            <div class="message received">
                <div class="message-content">
                    مرحباً، كيف يمكنني مساعدتك؟
                    <small class="message-time">AM 10:00</small>
                </div>
            </div>

            <!-- Sent Message -->
            <div class="message sent">
                <div class="message-content">
                    أحتاج إلى توضيح حول المشروع الأخير.
                    <small class="message-time">AM 10:05</small>
                </div>
            </div>

            <!-- Received Message -->
            <div class="message received">
                <div class="message-content">
                    بالطبع. سأرسل التفاصيل قريباً.
                    <small class="message-time">AM 10:10</small>
                </div>
            </div>

        </div>
        <!-- Chat Input -->
        <div class="chat-input d-flex align-items-center px-3 py-2">
            <!-- <i class="bi bi-image me-3"></i> -->
            <i style="color: #286090;" class="fa-solid fa-image fa-xl me-3"></i>
            <!-- <i class="bi bi-mic me-2"></i> -->
            <i style="color: #286090;" class="fa-solid fa-microphone fa-xl me-3"></i>
            <input type="text" class="form-control" placeholder="...اكتب رسالتك" />
            <button style="background-color: #286090; color: #fff;" class="btn rounded-circle ms-2">
                <!-- <i class="bi bi-send"></i> -->
                <i class="fa-solid fa-paper-plane fa-rotate-by" style="--fa-rotate-angle: 50deg;"></i>
            </button>
        </div>

    </div>

</template>

<script>
export default {
    name: "ChatPage",
};
</script>

<style scoped>
input::placeholder {
    direction: rtl;
    /* تغيير اتجاه النص من اليمين لليسار */
    text-align: right;
    /* محاذاة النص إلى اليمين */
}

.chat-page {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #f1f1f1;
}

.message-content {
    display: flex;
    flex-direction: column;
}

.chat-header {
    background-color: #296080;
    color: #fff;
    font-size: 1rem;
}

.user-avatar {
    width: 40px;
    height: 40px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
}

.chat-messages {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
    background-color: #e7ebf0;
}

.message {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    margin-bottom: 10px;
}

.message-content {
    padding: 10px;
    border-radius: 10px;
    font-size: 0.9rem;
    word-wrap: break-word;
}

.message-time {
    font-size: 0.8rem;
    color: #888;
    text-align: right;
    margin-top: 5px;
}

.message.received .message-content {
    background-color: #fff;
    align-self: flex-start;
    border-radius: 0 10px 10px 10px;
    /* تعديل الزوايا لتناسب اليسار */
}

.message.sent .message-content {

    background-color: #296080;
    color: #fff;
    align-self: flex-end;
    border-radius: 10px 0 10px 10px;
    /* زوايا مناسبة */
    margin-left: auto !important;
    /* يضمن التراص إلى أقصى يمين */
    margin-right: 0;
    /* للتأكد من عدم وجود مسافة إضافية */
}


.message.sent .message-content small {
    color: #fff;
}

.chat-input {
    background-color: #e7ebf0;
    /* border-top: 1px solid #ccc; */
}

.chat-input input {
    flex: 1;
    border-radius: 20px;
}

.chat-input button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
}

@media (min-width: 768px) {
    .chat-messages {
        padding-left: 60px !important;
        padding-right: 60px !important;
    }
}

@media (min-width: 1068px) {
    .chat-messages {
        padding-left: 90px !important;
        padding-right: 90px !important;
    }
}
</style>
